import { VaccineType, PetType } from '@yawi/types';

export interface VaccineOption {
  value: VaccineType;
  label: string;
  description?: string;
}

export const VACCINE_OPTIONS: VaccineOption[] = [
  // Dogs
  { value: VaccineType.RABIES, label: 'Rabia', description: 'Vacuna antirrábica (anual)' },
  { value: VaccineType.DISTEMPER, label: 'Moquillo', description: 'Virus del moquillo canino' },
  { value: VaccineType.PARVOVIRUS, label: 'Parvovirus', description: 'Parvovirus canino' },
  { value: VaccineType.LEPTOSPIROSIS, label: 'Leptospirosis', description: 'Bacteria Leptospira' },
  { value: VaccineType.BORDETELLA, label: 'Bordetella', description: 'Tos de las perreras' },
  { value: VaccineType.HEPATITIS, label: 'Hepatitis', description: 'Hepatitis infecciosa canina' },
  // Cats
  { value: VaccineType.FELINE_LEUKEMIA, label: 'Leucemia Felina', description: 'Virus de leucemia felina (FeLV)' },
  { value: VaccineType.FELINE_CALICIVIRUS, label: 'Calicivirus Felino', description: 'Infección respiratoria' },
  { value: VaccineType.FELINE_PANLEUKOPENIA, label: 'Panleucopenia Felina', description: 'Parvovirus felino' },
  { value: VaccineType.FELINE_RHINOTRACHEITIS, label: 'Rinotraqueitis Felina', description: 'Herpesvirus felino tipo 1' },
  // General
  { value: VaccineType.DEWORMING, label: 'Desparasitación', description: 'Tratamiento antiparasitario' },
  { value: VaccineType.OTHER, label: 'Otra', description: 'Otra vacuna o tratamiento' },
];

export const DOG_VACCINES: VaccineOption[] = [
  { value: VaccineType.RABIES, label: 'Rabia', description: 'Vacuna antirrábica (anual)' },
  { value: VaccineType.DISTEMPER, label: 'Moquillo', description: 'Virus del moquillo canino' },
  { value: VaccineType.PARVOVIRUS, label: 'Parvovirus', description: 'Parvovirus canino' },
  { value: VaccineType.LEPTOSPIROSIS, label: 'Leptospirosis', description: 'Bacteria Leptospira' },
  { value: VaccineType.BORDETELLA, label: 'Bordetella', description: 'Tos de las perreras' },
  { value: VaccineType.HEPATITIS, label: 'Hepatitis', description: 'Hepatitis infecciosa canina' },
  { value: VaccineType.DEWORMING, label: 'Desparasitación', description: 'Tratamiento antiparasitario' },
  { value: VaccineType.OTHER, label: 'Otra', description: 'Otra vacuna o tratamiento' },
];

export const CAT_VACCINES: VaccineOption[] = [
  { value: VaccineType.RABIES, label: 'Rabia', description: 'Vacuna antirrábica (anual)' },
  { value: VaccineType.FELINE_LEUKEMIA, label: 'Leucemia Felina', description: 'Virus de leucemia felina (FeLV)' },
  { value: VaccineType.FELINE_CALICIVIRUS, label: 'Calicivirus Felino', description: 'Infección respiratoria' },
  { value: VaccineType.FELINE_PANLEUKOPENIA, label: 'Panleucopenia Felina', description: 'Parvovirus felino' },
  { value: VaccineType.FELINE_RHINOTRACHEITIS, label: 'Rinotraqueitis Felina', description: 'Herpesvirus felino tipo 1' },
  { value: VaccineType.DEWORMING, label: 'Desparasitación', description: 'Tratamiento antiparasitario' },
  { value: VaccineType.OTHER, label: 'Otra', description: 'Otra vacuna o tratamiento' },
];

export const GENERAL_VACCINES: VaccineOption[] = [
  { value: VaccineType.RABIES, label: 'Rabia', description: 'Vacuna antirrábica' },
  { value: VaccineType.DEWORMING, label: 'Desparasitación', description: 'Tratamiento antiparasitario' },
  { value: VaccineType.OTHER, label: 'Otra', description: 'Otra vacuna o tratamiento' },
];

export const VACCINES_BY_PET_TYPE: Record<PetType, VaccineOption[]> = {
  DOG: DOG_VACCINES,
  CAT: CAT_VACCINES,
  BIRD: GENERAL_VACCINES,
  OTHER: GENERAL_VACCINES,
};

export const getVaccinesByPetType = (petType: PetType): VaccineOption[] => {
  return VACCINES_BY_PET_TYPE[petType] || GENERAL_VACCINES;
};

export const getVaccineLabel = (vaccineType: VaccineType): string => {
  const option = VACCINE_OPTIONS.find(opt => opt.value === vaccineType);
  return option?.label || vaccineType;
};

export const getVaccineDescription = (vaccineType: VaccineType): string | undefined => {
  const option = VACCINE_OPTIONS.find(opt => opt.value === vaccineType);
  return option?.description;
};

export const getVaccinationStatus = (
  nextDoseAt: string | undefined
): { status: 'up_to_date' | 'upcoming' | 'overdue'; label: string; color: string } => {
  if (!nextDoseAt) {
    return { status: 'up_to_date', label: 'Al día', color: 'green' };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const nextDose = new Date(nextDoseAt);
  nextDose.setHours(0, 0, 0, 0);

  const diffTime = nextDose.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return { status: 'overdue', label: 'Vencida', color: 'red' };
  } else if (diffDays <= 30) {
    return { status: 'upcoming', label: `En ${diffDays} días`, color: 'yellow' };
  } else {
    return { status: 'up_to_date', label: 'Al día', color: 'green' };
  }
};
